export const items: { label: string, sectionId: string }[] = [
  { label: 'ГЛАВНАЯ', sectionId: 'main' },
  { label: 'Организатор', sectionId: 'organizers' },
  { label: 'Место проведения', sectionId: 'place' },
  { label: 'Специалисты', sectionId: 'coach' },
  { label: 'Цели', sectionId: 'goal' },
  { label: 'Сервисы', sectionId: 'services' },
  { label: 'ИНФОРМАЦИЯ', sectionId: 'schedule' },
  { label: '#WEAREGOLDSTAR', sectionId: 'images' },
  { label: 'РЕГИСТРАЦИЯ', sectionId: 'registration' },
];
